import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, of, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationsService } from '@shared/services/notifications.service';
import { BadResponseWithError } from '@shared/models/common.interface';
import { ReferralsAction } from '../actions/actions-type.action';
import { ReferralsService } from '../../services/referrals.service';

@Injectable({ providedIn: 'root' })
export class ReferralsEffect {
    fetchReferralsRequests$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ReferralsAction.fetchReferralsRequests),
            switchMap((payload) =>
                this.referralService
                    .fetchReferrals(
                        payload.id,
                        payload.isActive,
                        payload.includeExpired,
                        payload.includeNonBillableActions
                    )
                    .pipe(
                        map((items: any) =>
                            ReferralsAction.fetchReferralsRequestsSuccess({
                                payload: {
                                    items,
                                },
                            })
                        ),
                        catchError((response: BadResponseWithError) => {
                            this.notificationsService.showError(
                                response.error.message
                            );

                            return of(
                                ReferralsAction.fetchReferralsRequestsFailure({
                                    payload: response,
                                })
                            );
                        })
                    )
            )
        )
    );

    createReferralsRequest = createEffect(() =>
        this.actions$.pipe(
            ofType(ReferralsAction.createReferralsRequest),
            switchMap(({ payload }) =>
                this.referralService.createNewReferralRequest(payload).pipe(
                    mergeMap((request: any) => [
                        ReferralsAction.createReferralsRequestSuccess({
                            payload: {
                                request,
                            },
                        }),
                    ]),
                    catchError((response: BadResponseWithError) => {
                        this.notificationsService.showError(
                            response.error.message
                        );

                        return of(
                            ReferralsAction.createReferralsRequestFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );
    updateReferralsRequest = createEffect(() =>
        this.actions$.pipe(
            ofType(ReferralsAction.updateReferralsRequest),
            switchMap(({ payload }) =>
                this.referralService.updateReferralRequest(payload).pipe(
                    mergeMap((request: any) => [
                        ReferralsAction.updateReferralsRequestSuccess({
                            payload: {
                                request,
                            },
                        }),
                    ]),
                    catchError((response: BadResponseWithError) => {
                        this.notificationsService.showError(
                            response.error.message
                        );
                        return of(
                            ReferralsAction.updateReferralsRequestFailure({
                                payload: response,
                            })
                        );
                    })
                )
            )
        )
    );
    constructor(
        private actions$: Actions,
        private notificationsService: NotificationsService,
        private referralService: ReferralsService
    ) {}
}
